import request from '@/utils/request'
import qs from 'qs'

// const MOCK_URL: string = 'http://localhost:3000'
const MOCK_URL: string = ''
// ******************* IOS 列表接口 *********************

// ios-uping - IOS-待上架应用 - 列表
export const getIosUpingList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/waitOnline`,
    method: 'get',
    params: data
  })

// ios-signature - IOS-签名队列 - 列表
export const getIosSignatureList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/signQueue`,
    method: 'get',
    params: data
  })

// ios-uped - IOS-已上架 - 列表
export const getIosUpedList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/onlineOffline`,
    method: 'get',
    params: data
  })

// ios-downing - IOS-待下架应用 - 列表
export const getIosDowningList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/waitOffline`,
    method: 'get',
    params: data
  })

// ios-downed - IOS-已下架应用 - 列表
export const getIosDownedList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/offline`,
    method: 'get',
    params: data
  })

// ios-update - IOS-待更新列表
export const getIosUpdateList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/waitUpdate`,
    method: 'get',
    params: data
  })

// ios-record - IOS-应用更新记录列表
export const getIosRecordList = (data: any) =>
  request({
    url: `${MOCK_URL}/ios/versionLog`,
    method: 'get',
    params: data
  })

// IOS-获取 单个App 上架渠道列表
export function getIosAppChannelList(data: any) {
  return request({
    url: `/ios/onlineChannel`,
    method: 'get',
    params: data
  })
}

// ******************* IOS 操作接口 *********************

// IOS-上架渠道/新增渠道
export function putUpAppIos(data: IPutUpAppIos) {
  return request({
    url: `/ios/online`,
    method: 'post',
    data: qs.stringify(data)
  })
}
// IOS-下架渠道
export const putDownAppIos = (data: IPutDownAppIos) =>
  request({
    url: `/ios/offline`,
    method: 'post',
    data: qs.stringify(data)
  })

// IOS-标记待更新
export const markAppIos = (data: IMarkAppIos) =>
  request({
    url: `/ios/addWaitUpdate`,
    method: 'post',
    data: qs.stringify(data)
  })

// IOS-标记已更新
export const markedAppIos = (data: IMarkAppIos) =>
  request({
    url: `/ios/rmWaitUpdate`,
    method: 'post',
    data: qs.stringify(data)
  })

// IOS-移出待下架列表
export const removeDowningAppIos = <T extends IMarkAppIos>(data: T) =>
  request({
    url: `/ios/rmWaitOffline`,
    method: 'post',
    data: qs.stringify(data)
  })

// IOS-恢复上架
export const recoverUpAppIos = <T extends IPutUpAppIos>(data: T) =>
  request({
    url: `/ios/resume`,
    method: 'post',
    data: qs.stringify(data)
  })

// ******************* Android 列表接口 *********************
// android-uping - 列表
export const getAndroidUpingList = (data: any) =>
  request({
    url: `/android/stay_shelf_list`,
    method: 'get',
    params: data
  })
// android-uped - 列表
export const getAndroidUpedList = (data: any) =>
  request({
    url: `/android/shelfed_list`,
    method: 'get',
    params: data
  })
// android-downing - 列表
export const getAndroidDowningList = (data: any) =>
  request({
    url: `/android/wait_shelf_list`,
    method: 'get',
    params: data
  })
// android-downed - 列表
export const getAndroidDownedList = (data: any) =>
  request({
    url: `/android/shelf_down_list`,
    method: 'get',
    params: data
  })
// android-update - 列表
export const getAndroidUpdateList = (data: any) =>
  request({
    url: `/android/wait_update_list`,
    method: 'get',
    params: data
  })
// android-record - 列表
export const getAndroidRecordList = (data: any) =>
  request({
    url: `/android/app_update_list`,
    method: 'get',
    params: data
  })
// Android 获取应用上架渠道
export function getAndroidAppChannelList(data: any) {
  return request({
    url: `/android/onlineChannel`,
    method: 'get',
    params: data
  })
}
// ******************* Android 操作接口 *********************
// Android - 上架渠道/新增渠道
export const putUpAppAndroid = <T extends IPutUpAppIos>(data: T) =>
  request({
    url: `/android/shelf_up`,
    method: 'post',
    data: qs.stringify(data)
  })

// Android - 下架渠道
export const putDownAppAndroid = <T extends IPutDownAppIos>(data: T) =>
  request({
    url: `/android/shelf_down`,
    method: 'post',
    data: qs.stringify(data)
  })

// Android - 标记待更新
export const markAppAndroid = <T extends IMarkAppIos>(data: T) =>
  request({
    url: `/android/sign_wait_update`,
    method: 'post',
    data: qs.stringify(data)
  })

// Android - 标记已更新
export const markedAppAndroid = <T extends IMarkAppIos>(data: T) =>
  request({
    url: `/android/sign_update`,
    method: 'post',
    data: qs.stringify(data)
  })

// Android - 移出待下架列表
export const removeDowningAppAndroid = <T extends IMarkAppIos>(data: T) =>
  request({
    url: `/android/move_wait_shelf`,
    method: 'post',
    data: qs.stringify(data)
  })

// Android - 恢复上架
export const recoverUpAppAndroid = <T extends IPutUpAppIos>(data: T) =>
  request({
    url: `/android/shelf_up`,
    method: 'post',
    data: qs.stringify(data)
  })
